import React from 'react';
import { useSelector } from 'react-redux';
import { CardsWithTitlesGrid } from '@yme/organisms/cards-with-titles-grid';
import { getCommonLabels, getRTL } from '@yme/selectors/common';
export function CardsList({ cards, isRemoveBottomIndent }) {
    const commonLabels = useSelector(getCommonLabels);
    const isRightToLeft = useSelector(getRTL);
    if (cards?.length) {
        return (React.createElement(CardsWithTitlesGrid, { cards: cards, isRemoveBottomIndent: isRemoveBottomIndent, learnMoreLabel: commonLabels?.common_learnMore_link, isRightToLeft: isRightToLeft }));
    }
    return null;
}
CardsList.displayName = 'CardsList_AEMComponent';
